export default [
  {
    title: '¿En qué año se disputó por primera vez el Santiago ePrix?',
    badtext: 'Mal. Fue en el 2018',
    id: 1,
    options: [
      {
        id: 'a',
        text: '2016',
        correct: false
      },
      {
        id: 'b',
        text: '2018',
        correct: true
      },
      {
        id: 'c',
        text: '2017',
        correct: false
      },
      {
        id: 'd',
        text: '2015',
        correct: false
      },
    ]
  },
  {
    title: '¿Qué piloto ganó la primera carrera de la Fórmula E en Chile?',
    badtext: 'Mal. Fue Jean-Éric Vergne',
    id: 2,
    options: [
      {
        id: 'a',
        text: 'Jean-Éric Vergne',
        correct: true
      },
      {
        id: 'b',
        text: 'José María López',
        correct: false
      },
      {
        id: 'c',
        text: 'Sébastien Buemi',
        correct: false
      },
      {
        id: 'd',
        text: 'André Lotterer',
        correct: false
      },
    ]
  },
  {
    title: '¿Cuál fue el equipo campeón en la temporada 2017-18 de la competencia?',
    badtext: 'Mal. Fue Audi Sport ABT Schaeffler',
    id: 3,
    options: [
      {
        id: 'a',
        text: 'Renault e.dams',
        correct: false
      },
      {
        id: 'b',
        text: 'Mahindra Racing',
        correct: false
      },
      {
        id: 'c',
        text: 'Jaguar Panasonic Racing',
        correct: false
      },
      {
        id: 'd',
        text: 'Audi Sport ABT Schaeffler',
        correct: true
      },
    ]
  },
  {
    title: '¿Qué día se corre el Santiago ePrix 2019?',
    badtext: 'Mal. Es el sábado 26 de enero de 2019.',
    id: 4,
    options: [
      {
        id: 'a',
        text: 'domingo 27 de enero',
        correct: false
      },
      {
        id: 'b',
        text: 'sábado 26 de enero',
        correct: true
      },
      {
        id: 'c',
        text: 'sábado 2 de febrero',
        correct: false
      },
      {
        id: 'd',
        text: 'viernes 25 de enero',
        correct: false
      },
    ]
  },
  {
    title: '¿Quién ganó la primera fecha de la temporada en Arabia Saudita?',
    badtext: 'Mal. Fue António Félix da Costa',
    id: 5,
    options: [
      {
        id: 'a',
        text: 'António Félix da Costa',
        correct: true
      },
      {
        id: 'b',
        text: 'Lucas di Grassi',
        correct: false
      },
      {
        id: 'c',
        text: 'Felipe Massa',
        correct: false
      },
      {
        id: 'd',
        text: 'Jérôme d’Ambrosio',
        correct: false
      },
    ]
  },
  {
    title: '¿Cuál de estas ciudades no forma parte del calendario 2018-19?',
    badtext: 'Mal. Es Madrid.',
    id: 6,
    options: [
      {
        id: 'a',
        text: 'Berlín',
        correct: false
      },
      {
        id: 'b',
        text: 'Nueva York',
        correct: false
      },
      {
        id: 'c',
        text: 'Roma',
        correct: false
      },
      {
        id: 'd',
        text: 'Madrid',
        correct: true
      },
    ]
  },
  {
    title: '¿Qué piloto largó desde la Pole Position en la segunda fecha de Marraquech?',
    badtext: 'Mal. Sam Bird.',
    id: 7,
    options: [
      {
        id: 'a',
        text: 'Felipe Massa',
        correct: false
      },
      {
        id: 'b',
        text: 'Oliver Rowland',
        correct: false
      },
      {
        id: 'c',
        text: 'Sam Bird',
        correct: true
      },
      {
        id: 'd',
        text: 'Félix Rosenqvist',
        correct: false
      },
    ]
  },
  {
    title: '¿Cuál es la potencia máxima de los monoplazas Gen2 de la temporada 2018-19?',
    badtext: 'Mal. Son de 250kW.',
    id: 8,
    options: [
      {
        id: 'a',
        text: '250 kW',
        correct: true
      },
      {
        id: 'b',
        text: '240 kW',
        correct: false
      },
      {
        id: 'c',
        text: '220 kW',
        correct: false
      },
      {
        id: 'd',
        text: '260 kW',
        correct: false
      },
    ]
  },
  {
    title: '¿Cuántos equipos forman la grilla de la Fórmula E?',
    badtext: 'Mal. Son 11 equipos.',
    id: 9,
    options: [
      {
        id: 'a',
        text: '11',
        correct: true
      },
      {
        id: 'b',
        text: '12',
        correct: false
      },
      {
        id: 'c',
        text: '10',
        correct: false
      },
      {
        id: 'd',
        text: '13',
        correct: false
      },
    ]
  },
  {
    title: '¿Cuál de estos países no tiene un equipo en Fórmula E?',
    badtext: 'Mal. Arabia Saudita es el que no posee equipo.',
    id: 10,
    options: [
      {
        id: 'a',
        text: 'Japón',
        correct: false
      },
      {
        id: 'b',
        text: 'Estados Unidos',
        correct: false
      },
      {
        id: 'c',
        text: 'China',
        correct: false
      },
      {
        id: 'd',
        text: 'Arabia Saudita',
        correct: true
      },
    ]
  }
]